import React from 'react';
import PropTypes from 'prop-types';
import { useModalContext } from 'Views/Page/Contexts/ModalContext';
import { FDBox, FDPrimaryActionButton } from '@facet-wealth/design';
import { dataAttrs } from 'Helpers/Testing';

const AssumptionsAndDetails = ({ relationship }) => {
  const { loadModalCollectionByLink } = useModalContext();

  return (
    <FDBox>
      <FDPrimaryActionButton
        {...dataAttrs('assumptions-and-details-button')}
        label={relationship.meta('prompt')}
        onClick={() => loadModalCollectionByLink(relationship.link('related').url())}
        size={'lg'}
      />
    </FDBox>
  );
};

AssumptionsAndDetails.propTypes = {
  relationship: PropTypes.object.isRequired,
};
AssumptionsAndDetails.defaultProps = {};

export default AssumptionsAndDetails;
